/* RunNowComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./RunNowRenderer");
const Registrations = require("../../../../../../RegistrationNamespaces");
const _ = require("lodash");

const MAX_VIEW_SWITCH_ATTEMPTS = 10;

class RunNowComponent extends EventEmitter {
    constructor(osPlanDetailsViewModel) {
        super();
        this._osPlanDetailsViewModel = osPlanDetailsViewModel;
        this._logger = this._osPlanDetailsViewModel._logger;
        this._gameEditor = this._osPlanDetailsViewModel._gameEditor;
        //this._osPlanEntity = this._osPlanDetailsViewModel._gameEditor.planEntity;
        this._osPlanEntity = this._osPlanDetailsViewModel._gameEditor.getPlan();
        this._modalUserFeedback = this._osPlanDetailsViewModel._modalUserFeedback;
        this._userSession = this._osPlanDetailsViewModel._userSession;
        this._switchedToResults = false;
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    get logger() {
        return this._logger;
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "RunNowComponent.shutdown() error.");
            }
        );
    }

    // prettier-ignore
    set "$teve.ui.context" (context) { //jshint ignore:line
        this._context = context;
    }

    sendResponse(result) {
        this._context.resolve(result);
    }
    cancelAction() {
        this._context.reject({userRejected: true});
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    startPlan(/*workInput*/) {
        // Disable the buttons and hide the veil.
        // Once workId is available, switch the screen to results
        const progressCB = ({workId}) => {
            const renderer = _.get(this, "_osPlanDetailsViewModel._renderer");
            // After the switch this DOM belongs to the results view, so leave it alone
            if (renderer && !this._switchedToResults) {
                renderer._disableAllViewActions();
                renderer._setViewActionText("RunNowPlan", "Running...");
            }
            if (workId && this._gameEditor._runWorkId !== workId) {
                this._gameEditor._runWorkId = workId;
                this._switchedToResults = true;
                // The results view waits for the Execution record and hides the veil itself
                this._switchToResultsView(1);
            }
        };

        // Show progress veil before running the work
        if (this._modalUserFeedback) {
            this._modalUserFeedback.displayLoading({
                message: "Running your plan... This could take a moment",
            });
        }

        // Run the work with progressCB as the callback function
        return this._osPlanEntity.runPlanWork({}, progressCB).catch((err) => {
            this._logWarning({error: err}, "RunNowComponent.startPlan() - Error");
            return this._modalUserFeedback.displayError({error: {errorMsg: err}});
        });
    }

    /**
     * Switches to the results view, retrying while another view switch is in flight.
     * @param {number} attempt
     * @private
     */
    _switchToResultsView(attempt) {
        return this._gameEditor
            .setActiveView(Registrations.OS_PLAN_EDITOR_VIEW_RESULTS)
            .catch((err) => {
                if (_.get(err, "error") === "existingView" && attempt < MAX_VIEW_SWITCH_ATTEMPTS) {
                    _.delay(() => this._switchToResultsView(attempt + 1), attempt * 100);
                    return;
                }
                this._logWarning({error: err}, "RunNowComponent._switchToResultsView() - Error");
                return this._modalUserFeedback.hideDisplayed();
            });
    }

    /**
     * displayLoading() shuts this component down, clearing this._logger - go via the parent view.
     * @private
     */
    _logWarning(data, message) {
        const logger = this._logger || _.get(this, "_osPlanDetailsViewModel._logger");
        if (logger) {
            logger.warn(data, message);
        }
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = RunNowComponent;
